import React from 'react';
// import Header from './components/header/header';
import Planing from './components/Planing/planing';
import Trust from './components/Trust/Trust';
import Aboutus from './components/Aboutus/Aboutus';
import ServiceTabs from './components/Servies/ServiceTabs';
import Innovation from './components/innovation/Innovation';
import Technology from './components/Technology/Technology';
import Career from './components/Career/Career';
// import Footer from './components/Footer/Footer';
import Saas from './components/SaasProducts/Saas';
import Team from './components/xtTeams/Team';

const HomePage = () => {
  return (
    <>
      {/* <Header /> */}
      <Planing />
      <Aboutus />
      <ServiceTabs />
      <Innovation />
      <Saas />
      <Team />
      <Technology />
      <Career />
      {/* <Footer /> */}
    </>
  );
};

export default HomePage;